import { render } from "./OutputParser.vue?vue&type=template&id=10b28826&scoped=true"
import script from "./OutputParser.vue?vue&type=script&lang=js"
export * from "./OutputParser.vue?vue&type=script&lang=js"

import "./OutputParser.vue?vue&type=style&index=0&id=10b28826&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b28826"]])

export default __exports__